import * as React from 'react';
import Grid from '@mui/material/Grid';
import LinearProgress from '@mui/material/LinearProgress';
import { SortOppReportViewModel } from '../ViewModels/ReportViewModel';
import OppReportTable from './OppReportTable';

interface IMonthlyProps {
    reportLoaded: boolean;
    opps: SortOppReportViewModel[]
}

export default function MonthlyOppReport(props: IMonthlyProps) {
    
    return (
        <React.Fragment>
            {!props.reportLoaded ? <LinearProgress color="primary" /> :
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <OppReportTable opps={props.opps} />
                    </Grid>
                </Grid>
            }
        </React.Fragment>
    );
}